import './sidebar.scss';

import React, { useState, useEffect } from 'react';
import { Button, Container, Nav, NavItem, NavLink, Popover } from 'reactstrap';

import { AdminMenu, EntitiesMenu, AccountMenu, LocaleMenu } from '../menus';
import { useAppDispatch, useAppSelector } from '../../../../../../app/config/store';
import MenuItem from '../menus/menu-item';
import { translate, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faUser } from '@fortawesome/free-solid-svg-icons';
import { NavDropdown } from '../menus/menu-components';
import { useNavigate } from 'react-router';
import { SettingsPage } from '../../../modules/account/settings/settings';
import FeedbackModel from './feedbackModel';

import { ToggleSvg } from '../../icon-svg/icon';
import { getSubscription } from '../../../entities/case-forms/case-lawyer.reducer';
import { getEntity } from '../../../entities/case-forms/subscription-plan.reducer';

export interface ISidebarProps {
  isAuthenticated: boolean;
  isAdmin: boolean;
  ribbonEnv: string;
  isInProduction: boolean;
  isOpenAPIEnabled: boolean;
  currentLocale: string;
  isSidebarCollapsed: boolean;
  toggleSidebar: any;
}

const Sidebar = (props: ISidebarProps) => {
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showFeedback, setShowFeedback] = useState<boolean>(false);
  const [isPlanExpired, setPlanExpired] = useState<boolean>(false);
  const [planDetails, setPlanDetails] = useState<any>();
  const { firstName, lastName, login, id } = useAppSelector(state => state.authentication?.account);
  const { entities, loading, entity } = useAppSelector(state => state.subscriptionPlan);

  const navigate = useNavigate();

  useEffect(() => {
    const viewPlan = async () => {
      try {
        const plan: any = await getSubscription(id);

        if (!plan) {
          setPlanDetails({ displayName: 'Plan Upgrade' });
          return;
        }

        const endDate = plan.endDate ? new Date(plan.endDate) : null;
        const now = new Date();
        const isExpired = endDate ? now > endDate : false;
        setPlanExpired(isExpired);

        let displayName = '';

        switch (plan.stripePriceId) {
          case '2331':
          case '10311':
            displayName = '3-Month Access';
            break;
          case '2329':
          case '10321':
            displayName = '12-Month Access';
            break;
          case '2286':
          case '41091':
            displayName = 'Free';
            break;
          default:
            displayName = 'Plan Upgrade';
            break;
        }

        setPlanDetails({ ...plan, displayName });
      } catch (error) {
        console.error('Failed to fetch plan details:', error);
      }
    };

    if (id) viewPlan();
  }, [id, entity]);

  // useEffect(() => {
  //   const viewPlan = async () => {
  //     let displayName = entity ? entity?.name || '' : 'Plan Upgrade';
  //     if (entity?.name === '$49.0 every 3 months' || entity?.duration === '3 months'||entity?.name =='3-Month Access') {
  //       displayName = '3-Month Access';
  //     } else if (entity?.name === '$99.0 per year' || entity?.duration === 'year') {
  //       displayName = '12-Month Access';
  //     } else if (
  //       entity?.duration === '7 days' ||
  //       entity?.duration === '14 days'
  //     ) {
  //       displayName = 'Free';
  //     }
  //     setPlanDetails({ ...entity, displayName });
  //   };
  //   viewPlan();
  // }, [entity]);

  const togglePopover = () => {
    setPopoverOpen(!popoverOpen);
  };

  const handleLogOut = () => {
    navigate('/logout');
  };

  const handlePlans = () => {
    navigate('/plan');
    setPopoverOpen(!popoverOpen);
  };

  const toggle = () => {
    setShowModal(!showModal);
  };

  const handleNavigate = () => {
    const formStep = localStorage.getItem('step');
    if (formStep == '4') {
      navigate(`/report`);
    } else {
      navigate(`/step-1`);
    }
  };

  return (
    <div id="app-sidebar" className={`d-flex flex-column gap-2 ${props?.isSidebarCollapsed ? 'collapsed' : ''}`}>
      <button onClick={props?.toggleSidebar} className="sidebar-toggle-btn p-0 border-0 w-auto d-lg-none d-block">
        {props?.isSidebarCollapsed ? <ToggleSvg /> : <ToggleSvg />}
      </button>
      {!props?.isSidebarCollapsed && (
        <div className="sidebar-wrapper d-flex flex-column gap-2">
          <div className="logo">
            <div className="logo-icon text-center">
              <img src="content/images/cases/dyhaclogo.svg" alt="Logo" className="logo-img" onClick={() => handleNavigate()} />
            </div>
          </div>

          <div className="menu-items pt-2 flex-grow-1">
            <Button className="theme-btn" onClick={() => handleNavigate()}>
              {' '}
              Document your case
            </Button>
            <div className="nav-menu">
              <EntitiesMenu />
            </div>
          </div>

          <div className="logout-btn d-flex gap-2 align-items-center">
            {/* Sign out */}
            <div className="user-profile">
              <img src="content/images/cases/Avatar.png" alt="profile img" />
              {/* <FontAwesomeIcon icon={faUser} /> */}
            </div>
            <div className="content d-flex flex-column flex-grow-1 text-truncate">
              {/* <small>Welcome &#9995;</small> */}
              <div className="d-block fw-bold text-truncate">{login}</div>
              <div
                className="d-block text-truncate"
                style={{ color: isPlanExpired ? '#DC2626' : '#64748B', fontWeight: 500, fontSize: '14px' }}
              >
                <span>{isPlanExpired ? 'Plan Expired.' : planDetails?.displayName} </span>
                {isPlanExpired && (
                  <span
                    style={{
                      color: '#0EA5E9',
                      textDecoration: 'underline',
                      fontSize: '12px',
                      cursor: 'pointer',
                    }}
                    onClick={() => navigate('/plan')}
                  >
                    Renew Plan
                  </span>
                )}
              </div>
            </div>

            <FontAwesomeIcon icon={faAngleRight} id="Popover1" type="button" onClick={togglePopover} />
            <Popover flip placement="right" target="Popover1" trigger="legacy" toggle={togglePopover} isOpen={popoverOpen}>
              <div className="popover-content user-settings-popover">
                <div className="popover-user-header">
                  <img src="content/images/cases/Avatar.png" alt="avatar" className="avatar" />
                  <div className="user-info">
                    <h6 className="user-name mb-0">
                      {firstName ? firstName : ''} {lastName ? lastName : ''}{' '}
                    </h6>
                    <small className="user-email">{login}</small>
                  </div>
                </div>

                <hr className="divider" />

                {planDetails?.displayName && (
                  <div
                    className="popover-item d-flex justify-content-between align-items-center"
                    onClick={() => {
                      handlePlans();
                    }}
                  >
                    <div className="d-flex align-items-center">
                      <img
                        src="content/images/cases/plan.png"
                        alt="profile img"
                        style={{ width: '20px', height: '20px', marginRight: '8px' }}
                      />
                      <span>{planDetails?.displayName}</span>
                    </div>
                    <span className="badge upgrade">Upgrade</span>
                  </div>
                )}

                <div
                  className="popover-item"
                  onClick={() => {
                    setShowModal(true), setPopoverOpen(!popoverOpen);
                  }}
                >
                  <img
                    src="content/images/cases/gear.png"
                    alt="profile img"
                    style={{ width: '20px', height: '20px', marginRight: '8px' }}
                  />
                  User Settings
                </div>

                <hr className="divider" />
                <div className="popover-item" onClick={handleLogOut}>
                  <img
                    src="content/images/cases/door-closed.png"
                    alt="profile img"
                    style={{ width: '20px', height: '20px', marginRight: '8px' }}
                  />
                  Logout
                </div>
              </div>
            </Popover>
          </div>
          <div className="logout-btn d-flex gap-2 align-items-center">
            <div style={{ cursor: 'pointer' }} onClick={() => setShowFeedback(!showFeedback)}>
              <img src="content/images/cases/feedback.png" alt="Logo" />
            </div>
            <small>Share your Feedback </small>
          </div>
          <SettingsPage showModal={showModal} toggle={toggle} />
          <FeedbackModel showFeedback={showFeedback} toggle={() => setShowFeedback(!showFeedback)} />
        </div>
      )}
      {/* </Nav> */}
    </div>
  );
};

export default Sidebar;
